import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AppGlobals } from "app/app.globals";

import { Prestation } from "../../services/agenda/prestation";

@Component({
  selector: "ajouter-presta-dialog",
  templateUrl: "ajouter-presta-dialog.component.html",
})
export class AjouterPrestaDialog implements OnInit {
  isAgendaHeure: boolean = true;
  isAgendaHeureDebutFin: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<AjouterPrestaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data.code != undefined) {
      let presta = this.data.codes.filter((x) => x.CodePrestationCode === this.data.code);
      if (presta.length > 0) {
        this.isAgendaHeure = presta[0].CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE;
        this.isAgendaHeureDebutFin = presta[0].CodePrestationEncodageHeure == AppGlobals.CLE_ENCODAGE_HEURE_DUREE;
      }
    }

    console.log(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCodeChange(): void {
    let presta = this.data.codes.filter(
      (x) => x.CodePrestationCode === this.data.code
    )[0];
    this.isAgendaHeure =
      presta.CodePrestationCleUnite == AppGlobals.CLE_UNITE_HEURE;
    this.isAgendaHeureDebutFin =
      presta.CodePrestationEncodageHeure == AppGlobals.CLE_ENCODAGE_HEURE_DUREE;
  }
}
